export enum MapModalTypeEnum {
  /** Fin informativo (un punto) */
  SIMPLE = 'simple',
  /** Fin informativo (dos punto - APP Y ERP) */
  SIMPLE_TWO = 'simpleTwo',
  /** Fin informativo de visitas */
  VISIT_ROUTE = 'visitRoute',
  /** Agrupacion de clientes por socios, clientes, documentos, motivo de visita CON FILTRO*/
  GROUPED_WITH_FILTER = 'groupedWithFilter',
  /** Agrupacion de clientes por socios, clientes, documentos, motivo de visita SIN FILTRO*/
  GROUPED_WITHOUT_FILTER = 'groupedWithoutFilter',
  /** Recorrido de Viajes Globales */
  VISIT_ROUTE_GLOBAL_FILTER = 'groupedVisitFilter',
  /** Rutas por frecuencia Asignados/No asignados*/
  FRECUENCY_ROUTE = 'frecuency_route',
  /** Rutas por frecuencia */
  FRECUENCY_DATE_ROUTE = 'frecuency_date_route'
}

export enum MonitorDocumentTypeEnum {
  NONE = 'NONE',
  PROGRESS = 'PROGRESS',
  DELIVERY = 'DELIVERY',
  VISIT = 'VISIT',
  DOCUMENT = 'DOCUMENT'
}

export enum MapFilterTypeEnum {
  NORMAL = 'NORMAL',
  EXTRA_WITHOUT_TRIP = 'EXTRA_WITHOUT_TRIP', //Pedidos sin viajes
  EXTRA_UNATTENDED_ORDERS = 'EXTRA_UNATTENDED_ORDERS' //Pedidos sin atencion pasada
}